import { useEffect, useState } from "react";

const useOutsideClick = ref => {
    const [clickOutside, setClickOutside] = useState(false);

    useEffect(() => {
        document.addEventListener("click", handleClick);

        return () => document.removeEventListener("click", handleClick);
    });

    const handleClick = e => {
        ref.current && ref.current.contains(e.target)
            ? setClickOutside(false)
            : setClickOutside(true);
    };

    return clickOutside;
};

export { useOutsideClick };
// https://erikmartinjordan.com/menu-react
// this hook allows us to close something if we click outside the target of that thing
